import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { SubMenu, SubMenuWrapper } from '../../ui';

const Profile = () => {
  const { t } = useTranslation();

  const navigationItems = useMemo(() => {
    return [
      { label: t('profile.personalInfo'), value: 'info' },
      { label: t('globals.diploma'), value: 'diplomas' },
      { label: t('globals.password'), value: 'password' },
      { label: t('globals.notifications'), value: 'notifications' },
      { label: t('globals.gift'), value: 'gift' },
      { label: t('profile.betaFeatures'), value: 'beta-features' },
    ];
  }, [t]);

  return (
    <>
      <SubMenuWrapper>
        <SubMenu navigationItems={navigationItems} pathnameSplitIndex={2} />
      </SubMenuWrapper>
      <Outlet />
    </>
  );
};

export default Profile;
